import { RootState } from "store/store";
import { connect } from "react-redux";
import { setIsUnsavedChangeAvailable } from "store/common/unsaved-data/unsaved-data-actions";
import { getActiveEnvironmentMoniker } from "store/environments/environment-selectors";
import GuestTenants from "./GuestTenants";
import { setEmailSent } from "store/customers/customer-details/customer-details-actions";
import { setAddNewGuestTenant } from "store/environments/tenants/tenant-guest-tenants/tenant-guest-tenants-actions";
import withLoader from "hocs/withLoader/withLoader";
import withError from "hocs/withError/withError";
import { flowRight } from "lodash";

const mapStateToProps = (state: RootState) => ({
    envMoniker: getActiveEnvironmentMoniker(state),
    isAddNewGuestTenantOpened:
        state.guestTenantsReducer.isAddNewGuestTenantOpened,
});
const Container = connect(mapStateToProps, {
    setIsUnsavedChangeAvailable,
    setEmailSent,
    setAddNewGuestTenant,
})(GuestTenants);

const GuestTenantsContainer = flowRight(withLoader, withError)(Container);

export default GuestTenantsContainer;
